import React, { ReactElement } from 'react';
import { Immutable } from '@wds/utils';
import { Box } from '@wds/box';
import { IconBell } from '@wds/icons';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { NavButton } from '../nav-button';
import useStyles from './useStyles';

export type NotificationsIconProps = Immutable<{
  showNotifications: boolean;
  unreadNotificationsCount: number;
}> & {
  toggleNotifications(): void;
};

const NotificationsIcon = ({
  showNotifications,
  toggleNotifications,
  unreadNotificationsCount,
}: NotificationsIconProps): ReactElement => {
  const { notificationsBadge, notificationsBadgeContainer } = useStyles();

  const maxUnreadNotificationsCount =
    unreadNotificationsCount > 9 ? '9+' : unreadNotificationsCount;

  return (
    <Responsive minWidth="xl">
      {(matches: boolean) =>
        matches ? (
          <NavButton
            onClick={toggleNotifications}
            label="See my notifications"
            active={showNotifications}
          >
            <Box>
              {unreadNotificationsCount > 0 && (
                <div className={notificationsBadgeContainer}>
                  <div className={notificationsBadge}>
                    {maxUnreadNotificationsCount}
                  </div>
                </div>
              )}
              <IconBell title="Notifications icon" size="lg" />
            </Box>
          </NavButton>
        ) : (
          <List.Item
            onClick={toggleNotifications}
            affordance={
              unreadNotificationsCount > 0 ? (
                <div className={notificationsBadge}>
                  {maxUnreadNotificationsCount}
                </div>
              ) : undefined
            }
            role="button"
          >
            Notifications center
          </List.Item>
        )
      }
    </Responsive>
  );
};

export default NotificationsIcon;
export { NotificationsIcon };
